import {createStore, applyMiddleware, compose} from 'redux'
import thunkMiddleware from 'redux-thunk'
import promiseMiddleware from 'redux-promise-middleware'
import {createLogger} from 'redux-logger'
import rootReducer from './reducers'

import { createMiddleware } from 'redux-gtm';
import eventDefinitionsMap from './utils/eventDefinitionsMap';

const gtmMiddleware = createMiddleware(eventDefinitionsMap);

const loggerMiddleware = createLogger();

function storeConfig(preloadedState) {

    const composeEnhancers = window.__REDUX_DEVTOOLS_EXTENSION_COMPOSE__ || compose;

    return createStore(
        rootReducer,
        preloadedState,
        composeEnhancers(
            applyMiddleware(
                thunkMiddleware,
                // loggerMiddleware,
                promiseMiddleware(),
                gtmMiddleware
            )
        )
    );
}

const store = storeConfig();

export default store;


// WEBPACK FOOTER //
// ./src/storeConfig.js